import { Injectable } from '@angular/core';
import { Machine } from '@shared/entities/machine';
import { Observable, interval, shareReplay, startWith, switchMap } from 'rxjs';
import { ApiService } from './api.service';
import { ActivatedRoute } from '@angular/router';
import { TIME_INTERVAL_REFRESH_MACHINES } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class MachineAlertService extends ApiService<Machine> {
  /**
   * Observable that emits the list of machines that are broken.
   * Broken machines are: KO or OFFLINE
   */
  broken$: Observable<Machine[]>;

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/machines';
    const detailUrl = '/machine-details/{id}';
    super(Machine, masterUrl, detailUrl, 'items');

    this.broken$ = interval(TIME_INTERVAL_REFRESH_MACHINES).pipe(
      startWith(0),
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }
        this.setUrlParameter('state', 'OFFLINE,KO');
        return this.findAll();
      }),
      shareReplay(1)
    );
  }
}
